import styled, { css, DefaultTheme } from 'styled-components';

import { setSvgColor } from 'styles/mixins';
import { ButtonVariant, ButtonColor } from 'constants/enums';

import { IButton } from './types';

const config = (theme: DefaultTheme, bVariant: string, bPalette: string) => {
  const { palette, ...props } = theme.configs.button[bVariant as ButtonVariant];

  return {
    ...props,
    ...palette[bPalette as ButtonColor],
  };
};

export const StyledButton = styled.button<IButton>`
  border-radius: 12px;

  outline: none;
  cursor: pointer;
  white-space: nowrap;

  ${({ theme, variant, palette }) => css`
    height: ${config(theme, variant, palette).height};
    min-width: ${config(theme, variant, palette).minWidth};
    border: ${config(theme, variant, palette).border};

    border-color: ${config(theme, variant, palette).bgColor.main};
    background-color: ${variant === 'default'
      ? config(theme, variant, palette).bgColor.main
      : 'transparent'};

    color: ${config(theme, variant, palette).text.main};
    ${setSvgColor(config(theme, variant, palette).text.main)};

    &:hover:enabled {
      background-color: ${variant === 'default'
        ? config(theme, variant, palette).bgColor.hover
        : 'transparent'};
      border-color: ${config(theme, variant, palette).bgColor.hover};
      color: ${config(theme, variant, palette).text.hover};
      ${setSvgColor(config(theme, variant, palette).text.hover)};
    }

    &:active:enabled {
      background-color: ${variant === 'default'
        ? config(theme, variant, palette).bgColor.active
        : 'transparent'};
      border-color: ${config(theme, variant, palette).bgColor.hover};
      color: ${config(theme, variant, palette).text.active};
      ${setSvgColor(config(theme, variant, palette).text.active)};
    }

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }
  `};
`;
